// extracted by mini-css-extract-plugin
var _1 = "#007ac9";
var _2 = "#575757";
var _3 = "disabledHoverButton-xnvY";
var _4 = "1.5rem";
var _5 = "#dedede";
var _6 = "#adf";
var _7 = "1rem";
var _8 = "#bebebe";
var _9 = "removeButton-xZbo";
var _a = "routeActiveSchedulesWrapper-jq__";
var _b = ".8rem";
var _c = "#000";
export { _1 as "busBlue", _2 as "darkGrey", _3 as "disabledHoverButton", _4 as "extraLargeFontSize", _5 as "lightGrey", _6 as "lightblue", _7 as "mediumFontSize", _8 as "mediumLightGrey", _9 as "removeButton", _a as "routeActiveSchedulesWrapper", _b as "smallFontSize", _c as "unusedNodeColor" }
